export default "__VITE_ASSET__592af475__"